import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  static values = {
    show: Boolean
  }

  static targets = ['overlay']

  connect() {
    this.element.querySelector('nav').classList.add('transition-all')
    this.overlayTarget.addEventListener('click', this.toggle.bind(this))
  }

  toggle() {
    this.showValue = !this.showValue
  }
}
